import { CustomComponentsProps } from '../../..';
import { ACCOMMODATIONS_ACTIONS } from '../../Accommodations.constants';

type ActionType = ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_ADD;

export interface AddAccommodationsProps
  extends CustomComponentsProps,
    Readonly<{
      type: ActionType;
      isEditMode?: boolean;
      componentId: string;
    }> {}

export enum AccommodationPlaceType {
  Hotel = 'Hotel',
  GetRoomBlock = 'GetRoomBlock',
  RoomBlock = 'Roomblock',
  Custom = 'Custom',
}
